<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong
            class="card-title mb-3"
          >{{(isAdd)? 'Add Scheme' : (pname)? pname+ ' Details': 'Details'}}</strong>
        </div>
        <!-- <div class="col-md-2">
          <download v-if="!isAdd" :tableId="'users'" :fileName="'portfolios-details'"></download>
        </div>-->
        <!-- <div class="col-md-1">
          <goback></goback>
        </div>-->
      </div>
    </div>
    <div class="card-body mb-15" v-if="isAdd">
      <AddScheme :pid="portId" @submitForm="submitForm"></AddScheme>
    </div>
    <div class="card-body mb-15" v-if="!isAdd">
      <div class="row mb5">
        <div class="col-md-10"></div>
        <!-- <div class="col-md-1"></div> -->
        <div class="col-md-2">
          <button type="button" @click="addNew()" class="btn btn-sm btn-success pull-right">
            <i class="fa fa-plus"></i> Add Scheme
          </button>
        </div>
      </div>
      <div class="table-responsive app mb-15" v-dragscroll="true">
        <div class="row mb5">
          <div class="col-md-10"></div>
          <div class="col-md-2">
            <download :tableId="'schemes'" :fileName="'schemes'"></download>
          </div>
        </div>
        <table id="schemes" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-if="actions.length>0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData.portfolio" v-bind:key="'row'+index">
              <td>{{index+1}}</td>
              <td v-for="field in tableFields" v-bind:key="field.name">
                <span v-if="field.name==='status'">{{(row['status']===false)? 'Inactive':'Active'}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td v-if="actions.length>0">
                <div class="action-btn-wrapper">
                  <a
                    style="margin:1px 4px"
                    class="btn btn-sm btn-small"
                    :class="action.btnClass"
                    v-for="(action, index) in actions"
                    v-bind:key="index+'-action-'+action.tooltip"
                    @click.prevent="action.callback(row,index,$event)"
                  >
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.portfolio && fillableData.portfolio.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="pull-right" v-if="totalPages>1">
          <ul v-if="this.totalPages != 1" class="pagination">
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
            </li>
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
            </li>
            <li
              v-for="(page, index) in pages"
              v-bind:key="index+page"
              class="page-item"
              :class="(current_page == page)? 'active':''"
            >
              <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-12">
        <div class="table-responsive app mb-15" v-dragscroll="true">
          <div class="row mb5">
            <div class="col-md-10"><h4>Fundwise</h4></div>
            <div class="col-md-2">
              <download :tableId="'fundwise'" :fileName="'portfolio-fundwise'"></download>
            </div>
          </div>
          <table class="table" id="fundwise">
            <thead>
              <tr>
                <th>Sr.</th>
                <th
                  v-for="field in stockTableFields"
                  v-bind:key="'field'+field.title"
                >{{field.name}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row,index) in fillableData.fundwise" v-bind:key="'row'+index">
                <td>{{index+1}}</td>
                <td v-for="field in stockTableFields" v-bind:key="field.name+index">
                  <span v-if="field.type==='string'">{{row[field.title]}}</span>
                  <span v-else>
                    <span v-if="field.type==='number'"> 
                      <span v-if="field.unit==='(%)'"> {{(row[field.title])? getFixed(row[field.title]*100): getFixed(row[field.title])}}</span>
                      <span v-else>{{getFixed(row[field.title])}}</span>
                    </span>
                    <span v-else>{{getFixed(row[field.title])}}</span>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <div class="row mb5">
              <div class="col-md-10"><h4>Categorywise</h4></div>
              <div class="col-md-2">
                <download :tableId="'categorywise'" :fileName="'categorywise'"></download>
              </div>
            </div>
            <table class="table" id="categorywise" >
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th
                    v-for="field in sectorTableFields"
                    v-bind:key="'field'+field.title"
                  >{{field.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in fillableData.categorywise" v-bind:key="'row'+index">
                  <td>{{index+1}}</td>
                  <td v-for="field in sectorTableFields" v-bind:key="field.title+index">
                    <span v-if="field.type==='string'">{{row[field.title]}}</span>
                    <span v-else>
                      <span
                        v-if="field.type==='number'"
                      >
                        <span v-if="field.unit==='(%)'">{{(row[field.title])? getFixed(row[field.title]*100): row[field.title]}}</span>
                        <span v-else>{{(row[field.title])? getFixed(row[field.title]): row[field.title]}}</span>
                      </span>
                      <span v-else>{{getCustomLabel(row[field.title])}}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <div class="row mb5">
              <div class="col-md-10"><h4>Fund type-wise</h4></div>
              <div class="col-md-2">
                <download :tableId="'fundtypewise'" :fileName="'fundtypewise'"></download>
              </div>
            </div>
            <table class="table" id="fundtypewise">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th
                    v-for="field in mcapTableFields"
                    v-bind:key="'field'+field.title"
                  >{{field.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in fillableData.maincategorywise" v-bind:key="'row'+index">
                  <td>{{index+1}}</td>
                  <td v-for="field in mcapTableFields" v-bind:key="field.title+index">
                    <span v-if="field.type==='string'">{{(row[field.title])}}</span>
                    <span v-else>
                      <span
                        v-if="field.type==='number'"
                      >
                        <span v-if="field.unit==='(%)'" >{{(row[field.title])? getFixed(row[field.title]): row[field.title]}}</span>
                        <span v-else>{{getFixed(row[field.title])}}</span>
                      </span>
                      <span v-else>{{getCustomLabel(row[field.title])}}</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-if="fillableData && fillableData.returns_accross_time_periods && fillableData.returns_accross_time_periods.length">
        <div class="row mb5">
          <div class="col-md-10"><h4>Returns across time periods</h4></div>
          <div class="col-md-2">
            <download :tableId="'returns'" :fileName="'returns'"></download>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered" id="returns">
            <thead>
              <tr>
                <th
                  v-for="(hd, index) in compositeIndex"
                  :key="'portfolio'+index"
                  class="text-center"
                >{{hd.name}}</th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr v-for="let port of portfolios.sensex_index[1]"> -->
              <tr v-for="(portIndex, index1) in fillableData.returns_accross_time_periods" v-bind:key="'compositeindex'+index1">
                <td
                  v-for="(hd, index) in compositeIndex"
                  :key="'portfoliotd'+index"
                  :class="{'text-right': hd.type==='numeric'}"
                >
                  <span
                    v-if="hd.type==='numeric'"
                  >{{(hd.unit==='(%)')? getFixed(portIndex[hd.title] * 100) : getFixed(portIndex[hd.title])}}</span>
                  <span v-if="hd.type==='string'">{{portIndex[hd.title]}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!------ GRAPH DATA ------>

      <div class="col-md-12" v-if="fillableData && fillableData.portfolio_graph">
        <div class="row mb5">
          <div class="col-md-10"><h4>Graph Data</h4></div>
          <div class="col-md-2">
            <download :tableId="'portfoliograph'" :fileName="'portfoliograph-data'"></download>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table table-bordered" id="portfoliograph">
            <thead>
              <tr>
                <th
                  v-for="(hd, index) in portfolioGraphDataKeys"
                  :key="'portfoliographth'+index"
                  class="text-center"
                >{{hd.name}}</th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr v-for="let port of portfolios.sensex_index[1]"> -->
              <tr v-for="(portIndex, index1) in fillableData.portfolio_graph" v-bind:key="'portfoliograph'+index1">
                <td
                  v-for="(hd, index) in portfolioGraphDataKeys"
                  :key="'portfoliographtd'+index"
                  :class="{'text-right': hd.type==='numeric'}"
                >
                  <span
                    v-if="hd.datatype==='numeric'"
                  >{{(hd.unit==='(%)')? getFixed(portIndex[hd.title] * 100) : getChecknFixed(portIndex[hd.title])}}</span>
                  <span v-if="hd.datatype==='string'">{{portIndex[hd.title]}}</span>
                  <span v-if="hd.datatype==='date'">{{(portIndex[hd.title]).split("T")[0]}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../../assets/mixins/common.js";
import AddScheme from "./add-scheme.vue";
export default {
  mixins: [commonMixins],
  name: "PortfolioDetails",
  components: { AddScheme },
  created() {
    if (!this.$route.params.id) {
      this.$router.push({ name: "portfolios" });
    }
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    this.portId = this.$route.params.id;
    this.pname = this.$route.params.name;
    // this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData(this.portId);
    // this.getPortfolioOutput();
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
    }
  },
  data() {
    return {
      isAdd: false,
      pname: "",
      apiUrl: "mutual-funds/portfolio",
      apiMode: true,
      company: {},
      actions: [
        // {
        //   btnClass: "btn-primary",
        //   icon: "fa-edit cwhite",
        //   callback: this.editPortfolio,
        //   tooltip: "Edit portfolio"
        // }
        // {
        //   btnClass: "btn-success",
        //   icon: "fa-eye cwhite",
        //   callback: this.viewPortfolio,
        //   tooltip: "View portfolio"
        // }
      ],
      tableFields: [
        {
          name: "sch_name",
          title: "Scheme Name"
        },
        {
          name: "Category",
          title: "Category"
        },
        {
          name: "LatestNAV",
          title: "Latest NAV"
        },
        {
          name: "date_of_purchase",
          title: "Purchase Date"
        },
        {
          name: "no_of_units_purchased",
          title: "No of Units Purchased"
        },
        {
          name: "price_per_units",
          title: "Purchase Price"
        },
        {
          name: "date_of_sale",
          title: "Sell Date"
        },
        {
          name: "no_of_units_sold",
          title: "No of Units Sold"
        },
        {
          name: "price_at_which_sold",
          title: "Sell Price"
        }
        // {
        //   name: "status",
        //   title: "Status"
        // }
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      stockTableFields: [
        { title: "sch_name", name: "Scheme Name", type: "string", unit: "" },
        { title: "Category", name: "Category", type: "string", unit: "" },
        { title: "MainCategory", name: "Main Category", type: "string", unit: "" },
        {
          title: "no_of_units_held",
          name: "No of Units held",
          type: "string",
          unit: ""
        },
        {
          title: "LatestNAV",
          name: "Latest NAV",
          type: "number",
          unit: ""
        },
        {
          title: "LatestValue",
          name: "Latest Value",
          type: "number",
          unit: ""
        },
        {
          title: "LV_By_TV",
          name: "LV/TV",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_one_day_price",
          name: "One Day Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_today",
          name: "Today's Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_one_week_price",
          name: "1Week Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_one_month_previous_price",
          name: "1Month Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_three_month_previous_price",
          name: "3Months Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_six_month_previous_price",
          name: "6Months Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_last_year_price",
          name: "1Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_two_year_previous_price",
          name: "2Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_three_year_previous_price",
          name: "3Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_five_year_previous_price",
          name: "5Year Price",
          type: "number",
          unit: ""
        },
        {
          title: "price_no_of_share_inception_date_price",
          name: "Inception Price",
          type: "number",
          unit: ""
        },
      ],
      sectorTableFields: [
        { title: "Category", name: "Category", type: "string", unit: "" },
        {
          title: "LV_By_TV",
          name: "LV/TV",
          type: "number",
          unit: ""
        }
      ],
      mcapTableFields: [
        {
          title: "MainCategory",
          name: "Fund Type",
          type: "string",
          unit: ""
        },
        {
          title: "LV_By_TV",
          name: "LV/TV",
          type: "number",
          unit: ""
        }
      ],
      outputData: [],
      returnsData: [],
      compositeIndex: [
        {title: 'ind_type', name: '', type: 'string', unit: ''},
        { title: "one_day", name: "1 Day", type: "numeric", unit: "(%)" },
        { title: "one_week", name: "1 Week", type: "numeric", unit: "(%)" },
        { title: "one_month", name: "1 Month", type: "numeric", unit: "(%)" },
        { title: "three_month", name: "3 Month", type: "numeric", unit: "(%)" },
        { title: "six_month", name: "6 Month", type: "numeric", unit: "(%)" },
        { title: "one_year", name: "1 Year", type: "numeric", unit: "(%)" },
        { title: "two_year", name: "2 Year", type: "numeric", unit: "(%)" },
        { title: "three_year", name: "3 Year", type: "numeric", unit: "(%)" },
        { title: "five_year", name: "5 Year", type: "numeric", unit: "(%)" },
        {
          title: "inception_date",
          name: "Since Inception",
          type: "numeric",
          unit: "(%)"
        }
      ],
      portfolioGraphDataKeys: [
        { title: 'Date', name: 'Date', datatype: 'date'},
        { title: 'portfolio_index', name: 'Portfolio Index', datatype: 'numeric'},
        { title: 'portfolio', name: 'Portfolio Value', datatype: 'numeric'},
        { title: 'bse_500_index', name: 'BSE 500 Index', datatype: 'numeric'},
        { title: 'bse_500', name: 'BSE 500', datatype: 'numeric'},
        { title: 'bse_sensex_index', name: 'BSE Sensex Index', datatype: 'numeric'},
        { title: 'bse_sensex', name: 'BSE Sensex', datatype: 'numeric'},
      ]
    };
  },
  methods: {
    reset() {
      // window.location.reload();
      // this.$router.push({ name: "user-activity" });
      this.searchParams = {};
      this.pageToLoad = 1;
      this.current_page = 1;
      // this.url = this.apiUrl + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        http.get("/mutual-funds/portfolio/"+myself.portId, {}, function(error, response) {
          console.log(error, response);
          if(!error) {
            myself.fillableData = response;
            response.returns_accross_time_periods.forEach((returnVal, returnKey) => {
              myself.compositeIndex.forEach((indexVal, indexKey) => {
                console.log(returnVal, returnKey, indexVal, indexKey);
              });
            });
          } else {
            console.log('No data');
          }
        });
        // http.get(myself.url + '/' + myself.portId, (error, response) => {
        //   console.log(response);
        //   myself.fillableData = response;
        // });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    editPortfolio(row, index, $event) {
      console.log(row, index, $event);
      this.$router.push({
        name: "mfedit-scheme",
        params: { id: row._id, sid: this.portId, name: this.pname }
      });
    },
    addNew() {
      this.fetchData(this.portId);
      // this.getPortfolioOutput();
      this.isAdd = !this.isAdd;
    },
    submitForm(obj) {
      console.log("obj", obj);
      this.addNew();
    },
    getPortfolioOutput() {
      let params = { portfolio_id: this.portId };
      let _this = this;
      http.get(_this.url + '/' + _this.portId, function(error, response) {
        console.log(response);
        _this.outputData = response;
        _this.pname = _this.outputData.basic_info.portfolio_name;
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/portfolios/portfolio-details.vue